import { Action } from '@ngrx/store';

import { ErrorResponse } from '~shared/models/error-response.model';
import { IAccountInformation } from '~shared/models/account-information.model';


export enum UserActionTypes {
  LOAD_USER_INFO = '[Buyer] User load',
  LOAD_USER_INFO_SUCCESS = '[Buyer] User load success',
  LOAD_USER_INFO_FAILURE = '[Buyer] User load failure',

  USER_LOGOUT = '[Buyer] User logout'
}

export class LoadUserInfo implements Action {
  readonly type = UserActionTypes.LOAD_USER_INFO;
}
export class LoadUserInfoSuccess implements Action {
  readonly type = UserActionTypes.LOAD_USER_INFO_SUCCESS;

  constructor(public payload: {user: IAccountInformation}) {
  }
}
export class LoadUserInfoFailure implements Action {
  readonly type = UserActionTypes.LOAD_USER_INFO_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {
  }
}
export class UserLogout implements Action {
  readonly type = UserActionTypes.USER_LOGOUT;
}

export type UserActionsUnion =
  LoadUserInfo
  | LoadUserInfoSuccess
  | LoadUserInfoFailure
  | UserLogout;
